import React, { useState, useRef, useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";

import useTranslation from "../../../Hooks/UseTranslation/use-translation";
import {
  isAndroid,
  jhhMainFaqUrl,
  relativePath,
  whatsappNumber,
} from "../../../Constants/config";
import packageJson from "../../../../package.json";
import { _getItemFromSession } from "../../../Utils/Helpers/SessionKeys";
import {
  mailtoIntentHandler,
  whatsappIntentHanlder,
} from "../../../Utils/Helpers/JsBridgeHelper";
import { _setHelpAndSupportOpenStatus } from "../../../actions/actions";

import headPhoneIcon from "../../../Assets/Images/headPhoneIcon.svg";
import helpIcon from "../../../Assets/Images/helpIcon.svg";
import FAQIcon from "../../../Assets/Images/FAQIcon.svg";
import whatsappIcon from "../../../Assets/Images/whatsappIcon.svg";
import emailIcon from "../../../Assets/Images/emailIcon.svg";
import helpClose from "../../../Assets/Images/CloseMark.svg";
import arrowIcon from "../../../Assets/Images/dropDownArrow.svg";
import { raiseGAEvent } from "../../../Utils/network";

import "./chatBot.scss";
import { _getItemFromLocal } from "../../../Utils/Helpers/LocalKeys";
import { EPnP } from "../../../Utils/Enums/EPnP";
import Footer from "../../../HealthPatri/UI/Components/Footer";
import Loader from "../Loader";
import BackFunction from "../../../Assets/Images/BackFunction.svg";
import Modal from "../Modal";
import { EMyJio } from "../../../Utils/Enums/EMyJio";
import { getJHHID } from "../GetJHHID";
import { UAParser } from "ua-parser-js";
import _ from "lodash";
import { Elocation } from "../../../FitnessTracker/Utils/utils";

interface IPathNameToMessageObj {
  [key: string]: string;
}

const pathNameToMessageObj: IPathNameToMessageObj = {
  "/healthpatri": "ASSISTANCE_MESSAGE_FOR_HEALTH_PATRI",
  "/verify-family-pin": "ASSISTANCE_MESSAGE_FOR_MPIN",
  "/create-mpin": "ASSISTANCE_MESSAGE_FOR_MPIN",
  "/forgot-mpin": "ASSISTANCE_MESSAGE_FOR_MPIN",
  "/create-family-mpin": "ASSISTANCE_MESSAGE_FOR_MPIN",
  "/verify-pin": "ASSISTANCE_MESSAGE_FOR_MPIN",
  "/login": "ASSISTANCE_MESSAGE_FOR_OTHER",
  "/add-account": "ASSISTANCE_MESSAGE_FOR_OTHER",
  "/add-family-account": "ASSISTANCE_MESSAGE_FOR_OTHER",
  "/my-profile": "ASSISTANCE_MESSAGE_FOR_OTHER",
  "/add-profile": "ASSISTANCE_MESSAGE_FOR_OTHER",
  "/authorise": "ASSISTANCE_MESSAGE_FOR_OTHER",
};

const ChatBot = withRouter(() => {
  const location = window.location.href;

  const history = useHistory();
  const dispatch = useDispatch();
  const [showModal, _setShowModal] = useState(false);
  const helpRef = useRef<HTMLDivElement>(null);
  const [showTnCIframe, setShowTnCIframe] = useState(false);
  const [iframeIsLoading, setIframeIsLoading] = useState(false);
  const { t } = useTranslation();
  const [state] = useState({
    source_id: null,
  });
  const jhhID = getJHHID();
  const parser = new UAParser();
  const OSDetails = parser.getOS();
  const BrowserDetails = parser.getBrowser();
  const crm = _getItemFromLocal("cr");
  const crmData = crm ? JSON.parse(crm) : crm;
  const emailBody = _.get(crmData, "body", "");
  const greeting = emailBody.split(",")[0];
  const body = emailBody.split(",")[1];
  const emailDisclaimer = _.get(crmData, "disclaimer", "");
  const helpSupportEmail = _.get(crmData, "help_support_email", "");
  const emailSubject = _.get(crmData, "subject", "");

  const _handleFAQClick = async () => {
    const GAObject = {
      new_Category: "Healthpatri_Home",
      new_Action: "Help_FAQ",
      new_Label: "",
    };
    raiseGAEvent(GAObject);

    if (
      _getItemFromSession("_pnp") === "true" &&
      _getItemFromLocal("_sr") === EMyJio.SOURCE
    ) {
      await whatsappIntentHanlder({
        phone_number: "",
        text: "",
        value: jhhMainFaqUrl,
      });
    } else {
      setIframeIsLoading(true);
      setShowTnCIframe(true);
    }
  };

  const intentMail = isAndroid
    ? {
        subject: `${emailSubject}${jhhID}`,
        body: `${greeting},\n \n${body} \n \n 1.Browser Name:- ${BrowserDetails.name} \n 
      2.Browser Version:- ${BrowserDetails.version} \n 3.Operating system:- ${OSDetails.name} \n 
      4.Operating Version:- ${OSDetails.version} \n \n ${emailDisclaimer} `,
        email_id: helpSupportEmail,
      }
    : {
        subject: `${emailSubject}${jhhID}`,
        body: `${greeting},%0D%0A %0D%0A${body} %0D%0A %0D%0A 1.Browser Name:- ${BrowserDetails.name} %0D%0A 
      2.Browser Version:- ${BrowserDetails.version} %0D%0A 3.Operating system:- ${OSDetails.name} %0D%0A 
      4.Operating Version:- ${OSDetails.version} %0D%0A %0D%0A ${emailDisclaimer} `,
        email_id: helpSupportEmail,
      };
  const _handleWhatsappClick = async () => {
    const GAObject = {
      new_Category: "Healthpatri_Home",
      new_Action: "Help_whatsapp chat",
      new_Label: "",
    };
    raiseGAEvent(GAObject);
    const whatsApptext = pathNameToMessageObj[
      `${window.location.pathname.replace(relativePath, "")}`
    ]
      ? pathNameToMessageObj[
          `${window.location.pathname.replace(relativePath, "")}`
        ]
      : "ASSISTANCE_MESSAGE_FOR_OTHER";
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      t(whatsApptext)
    )}`;
    const hasJsBridge = await whatsappIntentHanlder({
      phone_number: whatsappNumber,
      text: whatsApptext,
      value: url,
    });
    if (hasJsBridge) {
      return;
    }
    const win = window.open(url, "_blank");
    //@ts-ignore
    win?.focus();
  };

  const hideTnCIframe = () => {
    setShowTnCIframe(false);
  };

  const windowBackHandler = () => {
    if (!showTnCIframe) {
      _setShowModal(false);
      dispatch(_setHelpAndSupportOpenStatus(false));
    } else if (showTnCIframe) {
      setShowTnCIframe(false);
    }
  };

  const onModalOpenHandler = () => {
    dispatch(_setHelpAndSupportOpenStatus(true));
  };

  const hideModal = () => {
    history.goBack();
  };

  useEffect(() => {
    return () => {
      window.onpopstate = null;
    };
  }, []);

  useEffect(() => {
    if (showModal) {
      dispatch(_setHelpAndSupportOpenStatus(true));
    }
  }, [showModal]);

  return (
    <div>
      {_getItemFromLocal("_sr")?.toLowerCase() !== EPnP.SOURCE.toLowerCase() &&
        !location.includes(Elocation.FitnessTracker) && (
          <img
            onClick={() => {
              _setShowModal(true);
              raiseGAEvent({
                new_Category: "Healthpatri_Home",
                new_Action: "Help button",
                new_Label: "",
              });
            }}
            src={headPhoneIcon}
            alt={t("HELP_AND_SUPPORT_ICON")}
            className="custom-icon"
          />
        )}
      {showModal && (
        <Modal
          isOpen={showModal}
          onExitClicked={hideModal}
          modalContainerOverlay={"chatbot-modal-overlay"}
          modalBodyContainerClassName={`chatbot-modal-container-body ${
            showTnCIframe ? "min-height-tnc" : ""
          }`}
          onModalOpenHandler={onModalOpenHandler}
          backKeyToCloseModal={true}
          windowBackHandler={windowBackHandler}
          modalContainerClassName={`chatbot-modal-body ${
            _getItemFromSession("_pnp") === "true" ? "plug-play" : ""
          } ${showTnCIframe ? "iframe-height" : ""}`}
        >
          {/* <div className={`chatbot-modal-body ${showTnCIframe? "height-of-chat-bot":""} `}> */}
          {showTnCIframe ? (
            <>
              {iframeIsLoading && (
                <Loader
                  smallLoader={true}
                  loaderDivClass="external-url-iframe-loader"
                  loaderImgClass="external-url-iframe-loader"
                />
              )}
              <>
                {!iframeIsLoading && (
                  <img
                    className="tnc-link-back-button"
                    src={BackFunction}
                    onClick={() => hideTnCIframe()}
                    height={"20px"}
                  />
                )}
                <iframe
                  className={`external-url-iframe ${
                    _getItemFromSession("_pnp") === "true" ? "pnp-mode" : ""
                  }`}
                  src={jhhMainFaqUrl}
                  onLoad={() => {
                    setIframeIsLoading(false);
                  }}
                />
              </>
            </>
          ) : (
            <div>
              <div className="chatbot-modal-body-cross">
                <img
                  onClick={() => {
                    _setShowModal(false);
                    history.goBack();
                  }}
                  src={helpClose}
                  alt={t("CROSS")}
                  className="cross-icon"
                />
              </div>
              <div className="chatbot-modal-body-top">
                <img
                  src={helpIcon}
                  alt={t("HELPER_IMAGE")}
                  className="helper-image"
                />
                <div className="chatbot-modal-body-top-text">
                  {t("HELP_FOR_EVERYTHING")}
                </div>
                <div className="chatbot-modal-body-top-subtext">
                  {t("CHOOSE_AS_PER_CONVENIENCE")}
                </div>
              </div>
              <div className="chatbot-modal-body-version">{`v${packageJson.version}`}</div>
              <div ref={helpRef} className="chatbot-modal-body-bottom">
                <div
                  className="chatbot-modal-body-icons"
                  onClick={_handleFAQClick}
                >
                  <div className="chatbot-modal-body-icons-left">
                    <img
                      src={FAQIcon}
                      alt={t("FAQ_ICON")}
                      className="helper-icon"
                    />
                    <div>
                      <div className="chatbot-modal-body-icons-text">
                        {t("FAQS")}
                      </div>
                      <div className="chatbot-modal-body-icons-subtext">
                        {t("FIND_OUT_ANSWER")}
                      </div>
                    </div>
                  </div>
                  <img
                    src={arrowIcon}
                    className="chatbot-modal-body-icons-arrow"
                    alt={t("ARROW_FOR_ENABLE_DISABLE_DATA")}
                  />
                </div>
                <div
                  className="chatbot-modal-body-icons"
                  onClick={_handleWhatsappClick}
                >
                  <div className="chatbot-modal-body-icons-left">
                    <img
                      src={whatsappIcon}
                      alt={t("WHATSAPP_ICON")}
                      className="helper-icon"
                    />
                    <div>
                      <div className="chatbot-modal-body-icons-text">
                        {t("WHATSAPP_CHAT")}
                      </div>
                      <div className="chatbot-modal-body-icons-subtext">
                        {t("AVAILABILITY")}
                      </div>
                    </div>
                  </div>
                  <img
                    src={arrowIcon}
                    className="chatbot-modal-body-icons-arrow"
                    alt={t("ARROW_FOR_ENABLE_DISABLE_DATA")}
                  />
                </div>
                <a
                  className="chatbot-modal-body-icons-email"
                  href={
                    _getItemFromSession("_pnp") === "true"
                      ? void 0
                      : `mailto:${helpSupportEmail}?subject=${emailSubject}${jhhID}&body=${greeting},%0D%0A %0D%0A${body} %0D%0A %0D%0A 1.Browser Name:- ${BrowserDetails.name} %0D%0A 
                2.Browser Version:- ${BrowserDetails.version} %0D%0A 3.Operating system:- ${OSDetails.name} %0D%0A 
                4.Operating Version:- ${OSDetails.version}  %0D%0A %0D%0A ${emailDisclaimer} `
                  }
                  onClick={() => {
                    mailtoIntentHandler(intentMail);
                    const GAObject = {
                      new_Category: "Healthpatri_Home",
                      new_Action: "Help_email",
                      new_Label: "",
                    };
                    raiseGAEvent(GAObject);
                  }}
                >
                  <div className="chatbot-modal-body-icons">
                    <div className="chatbot-modal-body-icons-left">
                      <img
                        src={emailIcon}
                        alt={t("EMAIL_ICON")}
                        className="helper-icon"
                      />
                      <div>
                        <div className="chatbot-modal-body-icons-text">
                          {t("EMAIL")}
                        </div>
                        <div className="chatbot-modal-body-icons-subtext">
                          {t("ANYTIME")}
                        </div>
                      </div>
                    </div>
                    <img
                      src={arrowIcon}
                      className="chatbot-modal-body-icons-arrow"
                      alt={t("ARROW_FOR_ENABLE_DISABLE_DATA")}
                    />
                  </div>
                </a>
              </div>
            </div>
          )}
          {!showTnCIframe && (
            <Footer
              shouldHide={
                (state.source_id &&
                  (state.source_id === "JioHealthHub" ||
                    state.source_id === "MyJio" ||
                    state.source_id === "JhhWebApp")) ||
                _getItemFromSession("_pnp") === "true"
              }
            />
          )}
          {/* </div> */}
        </Modal>
      )}
    </div>
  );
});

export default ChatBot;
